import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum RolesFormErrorStatesEnum {
    CreateRoleFailed = ErrorStateScheduleEnum.RolesFormStatesStartIndex,
    UpdateRoleFailed,
    UpdateRolePermissionsFailed,
    DeleteRoleFailed
}
